export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9615.b1fbb473.jpg";